// FIX 20260724-uploadmsg 容量超過モーダル（全プラン共通・4画面から呼ぶ共通部品）
const g = (name) => (typeof window !== 'undefined' ? window[name] : undefined);

const toBytesText = (bytes) => {
  const Shared = g('Shared');
  if (Shared && typeof Shared.formatBytes === 'function') return Shared.formatBytes(bytes);
  let v = Number(bytes) || 0;
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let i = 0;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i += 1; }
  return `${Math.round(v * 10) / 10}${units[i]}`;
};

const routePath = (name) => {
  const Routes = g('Routes');
  return (Routes && typeof Routes[name] === 'function') ? Routes[name]() : '#';
};

// プラン名は接頭辞なし（CreateCloud/アカポンの表記を含めない）
const planLabel = (info) => info.planNameOnly || info.currentPlanName || info.membershipPlanName || '';

export const isEnterprisePlan = (info = {}) => info.isEnterprise === true;

// FIX 20260724-uploadmsg 容量がすでに満杯か（ファイルを選ばない経路＝URL/Drive用）
// FIX 20260724-uploadmsg 容量情報が渡っていない画面向け。1回だけ取得して使い回す（連打しても再取得しない）
let _cachedInfo = null;
export const fetchCapacityInfo = async (info = {}, baseURL = null) => {
  if (info && info.maxUploadSize) return info;
  if (_cachedInfo) return _cachedInfo;
  try {
    const base = (typeof baseURL === 'string' && baseURL) ? baseURL : '/akaire_feature/akaires';
    const res = await fetch(base + '/uploaded_data_info' + window.location.search, {
      headers: { 'Accept': 'application/json' }, credentials: 'same-origin'
    });
    if (!res.ok) return {};
    _cachedInfo = await res.json();
    return _cachedInfo;
  } catch (e) {
    return {};
  }
};

export const isCapacityFull = (info = {}) => {
  const max = Number(info.maxUploadSize);
  if (!max) return false;
  return Number(info.usedDataSize) >= max;
};

// FIX 20260724-uploadmsg プラン変更／お問い合わせは押せない文字にする（リンクだとページ移動してしまうため）
const stripActionLinks = (html, planPath, contactPath) => {
  let out = String(html || '');
  [planPath, contactPath].forEach((p) => {
    if (!p || p === '#') return;
    const esc = p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp('<a[^>]*href="' + esc + '"[^>]*>([\\s\\S]*?)<\\/a>', 'g');
    out = out.replace(re, '<span style="color:#fff;">$1</span>');
  });
  out = out.replace(/プランを変更(?=\s*<\/span>)/g, 'プラン変更');
  // FIX 20260724-uploadmsg 「データ」リンクは別タブで開く（モーダルは開いたまま）
  out = out.replace(/<a (?![^>]*target=)/g, '<a target="_blank" rel="noopener" ');
  return out;
};

export const buildCapacityLimitMessage = (info = {}) => {
  const I18n = g('I18n');
  const base = {
    membership_plan_name: planLabel(info),
    max_upload_size: toBytesText(info.maxUploadSize),
    grantcharts_link: routePath('owner_all_akaire_files_path')
  };
  const planPath = routePath('owner_total_info_path');
  const contactPath = routePath('owner_contact_us_path');
  if (I18n && typeof I18n.t === 'function') {
    const msg = isEnterprisePlan(info)
      ? I18n.t('shared.warning_over_upload_limit_enterprise',
          Object.assign({}, base, { contact_link: contactPath }))
      : I18n.t('shared.warning_over_upload_limit',
          Object.assign({}, base, { new_subscription_link: planPath }));
    return stripActionLinks(msg, planPath, contactPath);
  }
  return `${base.membership_plan_name}プランのデータ容量（${base.max_upload_size}）を超過しました。<br/>データを削除するか、プランを変更してください。`;
};

const openPlanOrContact = (info) => {
  if (isEnterprisePlan(info)) { window.open(routePath('owner_contact_us_path')); return; }
  // 現在のプランのモーダルを直接開く
  const S = g('Subscription');
  if (S && typeof S.handleShowChangePlanHeaderModal === 'function') {
    S.handleShowChangePlanHeaderModal();
    return;
  }
  const $j = g('jQuery');
  const toggleBtn = $j ? $j('#plan-header-toggle-btn') : null;
  if (toggleBtn && toggleBtn.length > 0) { toggleBtn.trigger('click'); return; }
  window.open(routePath('owner_total_info_path'));
};

// FIX 20260724-uploadmsg ポップアップ内のプラン変更リンクを、モーダル起動に差し替える
const bindPlanLinkInPopup = (info) => {
  const $j = g('jQuery');
  if (!$j) return;
  const planPath = routePath('owner_total_info_path');
  setTimeout(() => {
    $j('.modal:visible').find(`a[href="${planPath}"]`).off('click.capacity').on('click.capacity', (e) => {
      e.preventDefault();
      e.stopPropagation();
      $j('.modal:visible').modal('hide');
      openPlanOrContact(info);
    });
  }, 0);
};

export const showCapacityLimitPopup = (info = {}, options = {}) => {
  const onClose = typeof options.onClose === 'function' ? options.onClose : () => {};
  // 自分が持ち主でない場合はプラン変更できないため、所有者への確認を案内する
  const notOwner = info.isOwner === false;
  const message = notOwner
    ? `${planLabel(info)}プランのデータ容量（${toBytesText(info.maxUploadSize)}）を超過しました。<br/>※このプロジェクトの所有者にご確認ください。`
    : buildCapacityLimitMessage(info);
  const Popup = g('Popup');
  if (!Popup || typeof Popup.confirm !== 'function') {
    const toastr = g('toastr');
    if (toastr && typeof toastr.error === 'function') toastr.error(message.replace(/<[^>]*>/g, ''));
    onClose();
    return;
  }
  if (notOwner) {
    Popup.confirm(message, {
      confirmText: '閉じる',
      cancelBtn: 'false',
      kind: 'akaire',
      success: () => { onClose(); }
    });
    return;
  }
  // FIX 20260724-uploadmsg 文中の「プランを変更」リンクもモーダルを開く（ページ移動させない）
  bindPlanLinkInPopup(info);
  Popup.confirm(message, {
    confirmText: isEnterprisePlan(info) ? 'お問い合わせ' : 'プラン変更',
    cancelText: '閉じる',
    kind: 'akaire',
    success: () => { onClose(); openPlanOrContact(info); },
    cancel: () => { onClose(); }
  });
};

export default showCapacityLimitPopup;
